const isGCP = false
const isDocker = false
const isFormalTest = false  //是否在開發機測試正式db

// const SERVIER_FORMAL = "http://3.129.175.168:5000/"
// const SERVER_TEST = isGCP?isDocker?"http://10.105.4.197:5050/":"http://104.155.216.26:5050/" :"http://3.129.175.168:5050/"
// const SERVER_DEVELOP = "http://localhost:5050/"

const SOCKET_HTTP = "https://"
const SOCKET_SERVER_TEST = SOCKET_HTTP+"/tsocket.stats-insight.com/"
const SOCKET_SERVER_DEVELOP = "http://localhost:5051/"

export const TYPE_FORMAL = 1   //1:正式機
export const TYPE_TEST = 2     //2:測試機
export const TYPE_DEVELOP = 3  //3:開發機

export const TYPE = TYPE_TEST     //1:正式機 2:測試機 3:開發機



export const WEBMYSTAT = 1
export const WEBI3HNK = 2
export const WEBIPACA = 3
export const WEB = WEBMYSTAT

class LoginPageInfo{
    constructor(type){
        switch(type){
            case WEBMYSTAT:
                this.CompanyName = "灼見運動數據"
                this.logo = "灼"
                this.API_SERVIER_FORMAL = "http://api.stats-insight.com/"
                // this.API_SERVIER_FORMAL = "http://18.180.174.223:5000/"
                this.API_SERVER_TEST = SOCKET_HTTP+"tapi.stats-insight.com/"
                // this.API_SERVER_TEST = "http://18.180.174.223:5050/"
                this.API_SERVER_DEVELOP =isFormalTest?"http://localhost:5000/": "http://localhost:5050/"
                this.SOCKET_SERVER_FORMALT = "http://socket.stats-insight.com/"
                // this.SOCKET_SERVER_FORMALT = "http://18.180.174.223:5051/"
                this.SOCKET_SERVER_TEST =  SOCKET_HTTP+"tsocket.stats-insight.com/"
                // this.SOCKET_SERVER_TEST = "http://18.180.174.223:5051/"
                this.SOCKET_SERVER_DEVELOP = isFormalTest?"http://localhost:5001/":"http://localhost:5051/"
                break;
            case WEBI3HNK:
                this.CompanyName = "海尼根"
                this.logo = "海"
                this.API_SERVIER_FORMAL = "http://13.230.200.128:5000/"
                this.SAPI_ERVER_TEST = isGCP?isDocker?"http://10.105.4.197:5050/":"http://104.155.216.26:5050/" :"http://13.230.200.128:5050/"
                this.SERVER_DEVELOP = "http://localhost:5050/"
                this.SOCKET_SERVER_TEST = "http://13.230.200.128:5051/"
                this.SOCKET_SERVER_DEVELOP = "http://localhost:5051/"
                break
            case WEBIPACA:
                this.CompanyName = "打卡人資"
                this.logo = "卡"
                this.API_SERVIER_FORMAL = "http://35.74.110.226:5000/"
                this.API_SERVER_TEST = isGCP?isDocker?"http://10.105.4.197:5050/":"http://104.155.216.26:5050/" :"http://35.74.110.226:5050/"
                this.SERVER_DEVELOP = "http://localhost:5050/"
                this.SOCKET_SERVER_TEST = "http://35.74.110.226:5051/"
                this.SOCKET_SERVER_DEVELOP = "http://localhost:5051/"
                break
            default:
                this.CompanyName = ""
                this.logo = ""
                break
        }
    }

    getTestString(){
        if(!isFormalTest && (TYPE === TYPE_DEVELOP || TYPE === TYPE_TEST)){
          return "(測試機)"
        }
        return ""
    }

    getCompanyName(){
        return this.CompanyName + this.getTestString()
    }

    getLogo(){
        return this.logo
    }

    getServerUrl(){
        var SERVER_URL = TYPE===TYPE_FORMAL?this.API_SERVIER_FORMAL:TYPE===TYPE_TEST?this.API_SERVER_TEST:this.API_SERVER_DEVELOP
        // console.log(SERVER_URL)
        return SERVER_URL
    }

    getSocketUrl(){
        return TYPE===TYPE_FORMAL?this.SOCKET_SERVER_FORMALT:TYPE===TYPE_TEST?this.SOCKET_SERVER_TEST:this.SOCKET_SERVER_DEVELOP
    }

}

export const loginPageInfo = new LoginPageInfo(WEB)

// const SERVER_URL = type===TYPE_FORMAL?SERVIER_FORMAL:type===TYPE_TEST?SERVER_TEST:SERVER_DEVELOP
export const SOCKETIO_URL = TYPE===TYPE_FORMAL?SOCKET_SERVER_TEST:TYPE===TYPE_TEST?SOCKET_SERVER_TEST:SOCKET_SERVER_DEVELOP

export const URL_ACCOUNT = loginPageInfo.getServerUrl() + "account/"
export const URL_MODULE= loginPageInfo.getServerUrl() + "module/"
export const URL_MODULE_PERMISSION= loginPageInfo.getServerUrl() + "modulePermission/"
export const URL_CATEGORY = loginPageInfo.getServerUrl() + "category/"
export const URL_MENU = loginPageInfo.getServerUrl() + "menus/"
export const URL_PAGE = loginPageInfo.getServerUrl() + "page/"
export const URL_ROLE = loginPageInfo.getServerUrl() + "role/"
export const URL_COMPANY = loginPageInfo.getServerUrl() + "company/"
export const URL_DEPARTMENT = loginPageInfo.getServerUrl() + "department/"
export const URL_PERMISSION = loginPageInfo.getServerUrl() + "permission/"
export const URL_SYSTEM = loginPageInfo.getServerUrl() + "system/"
export const URL_CONTRACTOR = loginPageInfo.getServerUrl() + "contractor/"
export const URL_EMPLOYEE = loginPageInfo.getServerUrl() + "employee/"
export const URL_CUSTOMERCONTRACT = loginPageInfo.getServerUrl() + "customerContract/"
export const URL_CUSTOMERPOSITION = loginPageInfo.getServerUrl() + "customerPosition/"
export const URL_CONTRACTORATTENDANCE = loginPageInfo.getServerUrl() + "contractorAttendance/"
export const URL_RECUITMENTCONTRACTOR = loginPageInfo.getServerUrl() + "recruitmentContractor/"
export const URL_RECUITMENTPERFORMANCECONTRACTOR= loginPageInfo.getServerUrl() + "recruitmentPerformanceContractor/"
export const URL_RECUITMENTCONTRACTORINSURANCE = loginPageInfo.getServerUrl() + "recruitmentContractorInsurance/"

export const URL_OPENDATA = loginPageInfo.getServerUrl() + "openData/"
export const URL_ADDR = loginPageInfo.getServerUrl() + "addr/"

export const URL_LOGIN = loginPageInfo.getServerUrl()+"login"
export const URL_UPLOADFILE = loginPageInfo.getServerUrl()+"uploadFile/"
export const URL_UPLOADALL = loginPageInfo.getServerUrl()+"uploadAll/"

//Account
export const URL_ACCOUNT_REGISTER = URL_ACCOUNT + 'register'
export const URL_ACCOUNT_GET_CLIENTADMIN_LISTPAGE = URL_ACCOUNT + 'getClientAdminListPage'
export const URL_ACCOUNT_GET_CLIENTADMIN_LIST = URL_ACCOUNT + 'getClientAdminList'
export const URL_ACCOUNT_ADD_CLIENTADMIN = URL_ACCOUNT + 'addClientAdmin'
export const URL_ACCOUNT_GET_CLIENTADMIN_DETAIL = URL_ACCOUNT + 'getClientAdminDetail'
export const URL_ACCOUNT_UPDATE_CLIENTADMIN = URL_ACCOUNT + 'updateClientAdmin'

export const URL_GET_SYSTEM_ACCOUNTLIST = URL_ACCOUNT + 'getSystemAccountList'
export const URL_CHECK_SYSTEM_ACCOUNT = URL_ACCOUNT + 'checkSystemAccount'
export const URL_ADD_SYSTEM_ACCOUNT = URL_ACCOUNT + 'addSystemAccount'
export const URL_GET_SYSTEM_ACCOUNTDETAIL = URL_ACCOUNT + 'getSystemAccountDetail'
export const URL_UPDATE_SYSTEM_ACCOUNT = URL_ACCOUNT + 'updateSystemAccount'
export const URL_GET_CASEOWNER_LIST = URL_ACCOUNT + 'getCaseOwnerList'

//SYSTEM
export const URL_ADD_SYSTEMPROMPT = URL_SYSTEM + 'addSystemPrompt'
export const URL_GET_SYSTEMPROMPT = URL_SYSTEM + 'getSystemPrompt'
export const URL_ADD_MANAGEMENTPROMPT = URL_SYSTEM + 'addManagementPrompt'
export const URL_GET_MANAGEMENTPROMPT = URL_SYSTEM + 'getManagementPrompt'
export const URL_GET_BANKNAME = URL_SYSTEM + 'getBankName'

//Module
export const URL_MODULE_GET_LIST = URL_MODULE + "getModuleList"
export const URL_MODULE_ADD = URL_MODULE + "addModule"
export const URL_MODULE_GET_DETAIL = URL_MODULE + "getModuleDetail"

//ModulePermission
export const URL_MODULE_PERMISSION_GET_LIST = URL_MODULE_PERMISSION + "getModulePermissionList"
export const URL_MODULE_PERMISSION_SET = URL_MODULE_PERMISSION + "setModulePermission"


//Category
export const URL_CATEGORY_GET_LIST = URL_CATEGORY + "getCategoryList"
export const URL_CATEGORY_ADD = URL_CATEGORY + "addCategory"
export const URL_CATEGORY_GET_DETAIL = URL_CATEGORY + "getCategoryDetail"
export const URL_CATEGORY_UPDATE = URL_CATEGORY + "updateCategory"

//Menu
export const URL_MENU_USERMENU = URL_MENU + "getUserMenu"
export const URL_MENU_REALMENU = URL_MENU + "getRealMenu"
export const URL_MENU_ADDHEADER = URL_MENU + 'addHeader'
export const URL_MENU_ADDTITLE = URL_MENU + 'addTitle'
export const URL_MENU_ADDITEM = URL_MENU + 'addItem'

//Page
export const URL_PAGE_ADD = URL_PAGE + 'add'
export const URL_PAGE_REALLIST = URL_PAGE + "RealList"
export const URL_PAGE_USERLIST = URL_PAGE + 'UserList'
export const URL_PAGE_GETPAGEID = URL_PAGE + 'getPageId'

//Role
export const URL_ROLE_GETPERMISSION = URL_ROLE + 'getPermission'
export const URL_ROLE_GET_CLIENTADMIN_LIST = URL_ROLE + 'getClientAdminList'
export const URL_ROLE_SETPERMISSION = URL_ROLE + 'setPermission'
export const URL_ROLE_ADD = URL_ROLE + 'addRole'
export const URL_ROLE_GET_DETAIL = URL_ROLE + 'getRoleDetail'
export const URL_ROLE_UPDATE = URL_ROLE + 'updateRole'

//Company
export const URL_COMPANY_COMPANYADD = URL_COMPANY + 'companyAdd'
export const URL_COMPANY_COMPANYEDIT = URL_COMPANY + 'companyEdit'
export const URL_COMPANY_ADD_FIRSTEMPLOYEE = URL_COMPANY + 'addFirstEmployee'
export const URL_COMPANY_COMPANYLIST = URL_COMPANY + 'companyList'
export const URL_COMPANY_COMPANYDETAIL = URL_COMPANY + 'getCompanyDetail'
export const URL_COMPANY_GET_INFO = URL_COMPANY + 'getCompanyInfo'
export const URL_COMPANY_ROLEADD = URL_COMPANY + 'roleAdd'
export const URL_COMPANY_ROLEEDIT = URL_COMPANY + 'roleEdit'
export const URL_COMPANY_ROLELIST = URL_COMPANY + 'roleList'
export const URL_COMPANY_ROLELISTBYCOMPANY = URL_COMPANY + 'roleListByCompany'
export const URL_COMPANY_DEPARTMENTADD = URL_COMPANY + 'departmentAdd'
export const URL_COMPANY_DEPARTMENTEDIT = URL_COMPANY + 'departmentEdit'
export const URL_COMPANY_DEPARTMENTLIST = URL_COMPANY + 'departmentList'

//Contractor
export const URL_CONTRACTOR_GET_RESUME_LIST = URL_CONTRACTOR + 'getContractorResumeList'
export const URL_CONTRACTOR_CHECK_RESUME = URL_CONTRACTOR + 'checkContractorResume'
export const URL_CONTRACTOR_ADD_RESUME = URL_CONTRACTOR + 'addContractorResume'
export const URL_CONTRACTOR_GET_RESUME_DETAIL = URL_CONTRACTOR + 'getContractorResumeDetail'
export const URL_CONTRACTOR_UPDATE_RESUME = URL_CONTRACTOR + 'updateContractorResume'
export const URL_CONTRACTOR_GET_SKILL = URL_CONTRACTOR + 'getSkill'
export const URL_CONTRACTOR_ADD_RESUME_OTHERDATA = URL_CONTRACTOR + 'addResumeOtherData'
export const URL_CONTRACTOR_GET_RESUME_OTHERDATA = URL_CONTRACTOR + 'getResumeOtherData'

//Employee
export const URL_EMPLOYEE_GET_RESUME_LIST = URL_EMPLOYEE + 'getEmployeeResumeList'
export const URL_EMPLOYEE_CHECK_RESUME = URL_EMPLOYEE + 'checkEmployeeResume'
export const URL_EMPLOYEE_ADD_RESUME = URL_EMPLOYEE + 'addEmployeeResume'
export const URL_EMPLOYEE_GET_RESUME_DETAIL = URL_EMPLOYEE + 'getEmployeeResumeDetail'
export const URL_EMPLOYEE_UPDATE_RESUME = URL_EMPLOYEE + 'updateEmployeeResume'
export const URL_EMPLOYEE_ADD_RESUME_OTHERDATA = URL_EMPLOYEE + 'addEmployeeResumeOtherData'
export const URL_EMPLOYEE_GET_RESUME_OTHERDATA = URL_EMPLOYEE + 'getEmployeeResumeOtherData'

//Department
export const URL_DEPARTMENT_GET_DEPARTMENT_LIST = URL_DEPARTMENT + 'getDepartmentList'
export const URL_DEPARTMENT_ADD_DEPARTMENT = URL_DEPARTMENT + 'addDepartment'
export const URL_DEPARTMENT_GET_DEPARTMENT_DETAIL = URL_DEPARTMENT + 'getDepartmentDetail'
export const URL_DEPARTMENT_UPDATE_DEPARTMENT = URL_DEPARTMENT + 'updateDepartment'

//Permission
export const URL_PERMISSION_GET_ROLE_LIST = URL_PERMISSION + 'getRolePermissionList'
export const URL_PERMISSION_GET_DEFAULT_LIST = URL_PERMISSION + 'getDefaultPermissionList'
export const URL_PERMISSION_SET_ROLE_PERMISSION = URL_PERMISSION + 'setRolePermission'

export const URL_UPLOAD_FILE = URL_UPLOADFILE + 'uploadFile'
export const URL_UPLOAD_ALL = URL_UPLOADALL + 'uploadFile'

//CustomerContract
export const URL_CUSTOMERCONTRACT_GET_LIST = URL_CUSTOMERCONTRACT + 'getCustomerContractList'
export const URL_CUSTOMERCONTRACT_ADD = URL_CUSTOMERCONTRACT + 'addCustomerContract'
export const URL_CUSTOMERCONTRACT_GET_DETAIL = URL_CUSTOMERCONTRACT + 'getCustomerContractDetail'

//CustomerPosition
export const URL_CUSTOMERPOSITION_GET_LIST = URL_CUSTOMERPOSITION + 'getCustomerPositionList'
export const URL_CUSTOMERPOSITION_ADD = URL_CUSTOMERPOSITION + 'addCustomerPosition'
export const URL_CUSTOMERPOSITION_GET_DETAIL = URL_CUSTOMERPOSITION + 'getCustomerPositionDetail'
export const URL_POSITIONDEMAND_GET_LIST = URL_CUSTOMERPOSITION + 'getPositionDemandList'
export const URL_POSITIONDEMAND_GET_DETAIL = URL_CUSTOMERPOSITION + 'getPositionDemandDetail'
//URL_CUSTOMERATTENDANCE
export const URL_CONTRACTORATTENDANCE_GET_LIST = URL_CONTRACTORATTENDANCE + 'getContractorAttendanceList'
export const URL_CONTRACTORATTENDANCE_GET_SOP1_LIST = URL_CONTRACTORATTENDANCE + 'getContractorAttendanceSOP1List'
export const URL_CONTRACTORATTENDANCE_GET_SOP1_COUNT = URL_CONTRACTORATTENDANCE + 'getContractorAttendanceSOP1Count'
export const URL_CONTRACTORATTENDANCE_ADD = URL_CONTRACTORATTENDANCE + 'addContractorAttendance'
export const URL_CONTRACTORATTENDANCE_UPDATE = URL_CONTRACTORATTENDANCE + 'updateContractorAttendance'
export const URL_CONTRACTORATTENDANCE_UPDATE_SOPSTATUS = URL_CONTRACTORATTENDANCE + 'updateContractorAttendanceSOPStatus'
export const URL_CONTRACTORATTENDANCE_GET_DETAIL = URL_CONTRACTORATTENDANCE + 'getCustomerAttendanceDetail'
export const URL_CONTRACTORATTENDANCE_GET_CUSTOMERPOSITION_RECRUITMENT_LIST = URL_CONTRACTORATTENDANCE + 'getCustomerAttendance_CustomerPosition_Recruitment_List'
export const URL_CONTRACTORATTENDANCE_GET_CUSTOMERPOSITION_RECRUITMENT_CONTRACTOR = URL_CONTRACTORATTENDANCE + 'getCustomerAttendance_CustomerPosition_Recruitment_Contractor'

//RecruitmentContractor
export const URL_RECUITMENTCONTRACTOR_GET_LIST = URL_RECUITMENTCONTRACTOR + 'getRecruitmentContractorStatusList'
export const URL_RECUITMENTCONTRACTOR_ADD = URL_RECUITMENTCONTRACTOR + 'addRecruitmentContractorStatus'
export const URL_RECUITMENTCONTRACTOR_UPDATE = URL_RECUITMENTCONTRACTOR + 'updateRecruitmentContractorStatus'
export const URL_RECUITMENTCONTRACTOR_GET_DETAIL = URL_RECUITMENTCONTRACTOR + 'getRecruitmentContractorStatusDetail'
export const URL_RECUITMENTCONTRACTOR_GET_PROCESS_LIST = URL_RECUITMENTCONTRACTOR + 'getRecruitmentContractorStatusProcessList'
export const URL_RECUITMENTCONTRACTOR_SET_BLACKLIST = URL_RECUITMENTCONTRACTOR + 'setBlacklist'

//RecruitmentContractorInsurance
export const URL_RECUITMENTCONTRACTORINSURANCE_GET = URL_RECUITMENTCONTRACTORINSURANCE + 'getRecruitmentContractorInsurance'
export const URL_RECUITMENTCONTRACTORINSURANCE_ADD = URL_RECUITMENTCONTRACTORINSURANCE + 'addRecruitmentContractorInsurance'
export const URL_RECUITMENTCONTRACTORINSURANCE_SET_LIST = URL_RECUITMENTCONTRACTORINSURANCE + 'setRecruitmentContractorInsuranceList'
export const URL_RECUITMENTCONTRACTORINSURANCE_GET_LIST = URL_RECUITMENTCONTRACTORINSURANCE + 'getRecruitmentContractorInsuranceList'

//RecruitmentPerformanceContractorRelated
export const URL_RECUITMENTPERFORMANCE_GET_COUNT = URL_RECUITMENTPERFORMANCECONTRACTOR + 'getRecruitmentPerformanceCount'
export const URL_RECUITMENTPERFORMANCECONTRACTOR_DEPARTMENT_GET_LIST = URL_RECUITMENTPERFORMANCECONTRACTOR + 'getRecruitmentPerformanceContractorDepartmentList'
export const URL_RECUITMENTPERFORMANCECONTRACTOR_SPECIALIST_GET_LIST = URL_RECUITMENTPERFORMANCECONTRACTOR + 'getRecruitmentPerformanceContractorSpecialistList'
export const URL_RECUITMENTPERFORMANCECONTRACTOR_RELATED_GET_LIST = URL_RECUITMENTPERFORMANCECONTRACTOR + 'getRecruitmentPerformanceContractorRelatedList'
export const URL_RECUITMENTPERFORMANCECONTRACTORRELATED_GET_DETAIL = URL_RECUITMENTPERFORMANCECONTRACTOR + 'getRecruitmentContractorStatusDetail'
export const URL_OPENDATA_GET_LABORINSURANCE = URL_OPENDATA + 'getLaborInsurance'
export const URL_OPENDATA_GET_HEALTHINSURANCE = URL_OPENDATA + 'getHealthInsurance'

export const URL_ADDR_GET_CITY_LIST = URL_ADDR + 'getCityList'
export const URL_ADDR_GET_DIST_LIST = URL_ADDR + 'getDistList'

export const body2String = (obj) =>{
    var str = "";
    for(var k in obj) {
        //console.log(obj[k]);
        if(str !== "")
            str += "&"
        str += k+"="+obj[k];
    }
    return str;
}

export const fetchBody = ({body, token}) =>{
    var Headers = {
        'Content-Type': 'application/json',
        'accept': 'application/json',
    }
    if(token !== undefined){
        Headers.Authorization = 'bearer '+token;
    }
    if(body === undefined)
        body = JSON.stringify({}) 
    else
        body = JSON.stringify(body) 
    return {
        crossDomain:true,
        method: 'POST',
        headers: Headers,
        /*
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        */
        // body 將 json 轉字串送出
        mode: 'cors',
        /*body: JSON.stringify({
            account: account,
            password: password
        })
        */
        body: body
    }
}

export const fetchUpload = ({body, token}) =>{
    var Headers = {
    }
    if(token !== undefined){
        Headers.Authorization = 'bearer '+token;
    }
    return {
        crossDomain:true,
        method: 'POST',
        headers: Headers,
        /*
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        */
        // body 將 json 轉字串送出
        mode: 'cors',
        /*body: JSON.stringify({
            account: account,
            password: password
        })
        */
        body: body
    }
}